import { Svg } from './svg'

export const LinkIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.707 7.29327C4.09752 7.68379 4.09752 8.31696 3.707 8.70748L3.207 9.20748C2.21681 10.1977
      2.21681 11.8031 3.207 12.7933C4.19718 13.7835 5.8026 13.7835 6.79278 12.7933L7.29278 12.2933C7.68331
      11.9027 8.31647 11.9027 8.707 12.2933C9.09752 12.6838 9.09752 13.317 8.707 13.7075L8.207
      14.2075C6.43576 15.9787 3.56402 15.9787 1.79278 14.2075C0.0215446 12.4362 0.021548 9.5645 1.79278
      7.79327L2.29278 7.29327C2.68331 6.90275 3.31647 6.90275 3.707 7.29327Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2928 8.70748C11.9023 8.31696 11.9023 7.68379 12.2928 7.29327L12.7928 6.79327C13.783 5.80308 13.783
      4.19767 12.7928 3.20748C11.8026 2.2173 10.1972 2.2173 9.20699 3.20749L8.707 3.70748C8.31647 4.09801 7.68331
      4.09801 7.29278 3.70748C6.90226 3.31696 6.90226 2.68379 7.29278 2.29327L7.79278 1.79327C9.56402 0.0220361
      12.4358 0.0220332 14.207 1.79327C15.9782 3.56451 15.9782 6.43625 14.207 8.20749L13.707 8.70748C13.3165
      9.09801 12.6833 9.09801 12.2928 8.70748Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.707 5.29327C11.0975 5.68379 11.0975 6.31696 10.707 6.70748L6.707 10.7075C6.31647 11.098 5.68331 11.098
      5.29278 10.7075C4.90226 10.317 4.90226 9.68379 5.29278 9.29327L9.29278 5.29327C9.68331 4.90275 10.3165
      4.90275 10.707 5.29327Z"
      fill="currentColor"
    />
  </Svg>
)
